// EntradaStock.js - Componente de Entrada e Saída de Stock (CORRIGIDO COM ARMAZÉNS NOS DROPDOWNS E NA SELEÇÃO)
// ✅ COM PESQUISA DE PRODUTO E PAGINAÇÃO NO HISTÓRICO
// ✅ BOTÃO DE SAÍDA DE STOCK COM POPUP INSPIRADO NO DE ENTRADA
// ✅ ROTA DE SAÍDA: POST /produtos/:id/saida-stock
// ✅ SAÍDAS MOSTRADAS COM SINAL NEGATIVO E COR VERMELHA
// ✅ BOTÕES DE SAÍDA COM SÍMBOLO "-" E BOTÕES DE ENTRADA COM SÍMBOLO "+"
// ✅ COLUNA ARMAZÉM NA TABELA, MODAL DE DETALHES E HISTÓRICO
// ✅ ARMAZÉM NOS DROPDOWNS DE PESQUISA DOS MODAIS
// ✅ ARMAZÉM NA SELEÇÃO DO PRODUTO NOS MODAIS
// ✅ CORREÇÃO: Verificação de produtos nulos nos dropdowns

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './EntradaStock.css';
import { Icon } from './SharedComponents';

const API_BASE_URL = '/api';

export default function EntradaStock() {
    // ==============================================
    // ESTADOS PRINCIPAIS
    // ==============================================
    const [produtos, setProdutos] = useState([]);
    const [filteredProdutos, setFilteredProdutos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [entradas, setEntradas] = useState([]);
    const [loadingEntradas, setLoadingEntradas] = useState(false);
    const [armazens, setArmazens] = useState([]);

    // ==============================================
    // MODAIS
    // ==============================================
    const [showEntradaModal, setShowEntradaModal] = useState(false);
    const [showSaidaModal, setShowSaidaModal] = useState(false);
    const [showDetalhesModal, setShowDetalhesModal] = useState(false);
    const [showHistoricoModal, setShowHistoricoModal] = useState(false);
    const [produtoSelecionado, setProdutoSelecionado] = useState(null);
    const [entradaSelecionada, setEntradaSelecionada] = useState(null);

    const [historicoProduto, setHistoricoProduto] = useState([]);
    const [loadingHistorico, setLoadingHistorico] = useState(false);

    // ==============================================
    // ESTADOS PARA PESQUISA DE PRODUTO NO POPUP
    // ==============================================
    const [searchProdutoPopup, setSearchProdutoPopup] = useState('');
    const [produtosFiltradosPopup, setProdutosFiltradosPopup] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    // ==============================================
    // PAGINAÇÃO PARA O HISTÓRICO DO PRODUTO (6 por página)
    // ==============================================
    const [historicoPagination, setHistoricoPagination] = useState({
        page: 1,
        limit: 6,
        total: 0,
        pages: 0
    });

    // ==============================================
    // FORM DATA - ENTRADA
    // ==============================================
    const [formData, setFormData] = useState({
        produtoId: '',
        quantidade: 1,
        precoUnitario: 0,
        fornecedorId: '',
        notaFiscal: '',
        dataEntrada: '',
        observacao: ''
    });

    // ==============================================
    // FORM DATA - SAÍDA
    // ==============================================
    const [saidaFormData, setSaidaFormData] = useState({
        produtoId: '',
        quantidade: 1,
        observacao: ''
    });

    // ==============================================
    // ESTADOS PARA PESQUISA DE PRODUTO NA SAÍDA
    // ==============================================
    const [searchProdutoSaida, setSearchProdutoSaida] = useState('');
    const [produtosFiltradosSaida, setProdutosFiltradosSaida] = useState([]);
    const [showDropdownSaida, setShowDropdownSaida] = useState(false);
    const dropdownSaidaRef = useRef(null);

    // ==============================================
    // ESTADOS ADICIONAIS
    // ==============================================
    const [fornecedores, setFornecedores] = useState([]);
    const [message, setMessage] = useState({ text: '', type: '' });
    const [submitting, setSubmitting] = useState(false);
    const [submittingSaida, setSubmittingSaida] = useState(false);
    const [stats, setStats] = useState({
        totalEntradas: 0,
        totalQuantidade: 0,
        valorTotal: 0,
        ultimaEntrada: null
    });

    // ==============================================
    // PAGINAÇÃO - ENTRADAS (5 por página)
    // ==============================================
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 5,
        total: 0,
        pages: 0
    });

    // ==============================================
    // PAGINAÇÃO - PRODUTOS (9 por página)
    // ==============================================
    const [produtosPagination, setProdutosPagination] = useState({
        page: 1,
        limit: 6,
        total: 0,
        pages: 0
    });

    // ==============================================
    // API INSTANCE
    // ==============================================
    const api = axios.create({
        baseURL: API_BASE_URL,
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Cache-Control': 'no-cache'
        }
    });

    // ==============================================
    // FUNÇÕES AUXILIARES
    // ==============================================
    const showToast = (text, type = 'success') => {
        setMessage({ text, type });
        setTimeout(() => setMessage({ text: '', type: '' }), 4000);
    };

    const formatarMoeda = (valor) => {
        if (valor === undefined || valor === null || isNaN(valor)) {
            return '0,00 MT';
        }
        return Number(valor).toLocaleString('pt-PT', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }) + ' MT';
    };

    const formatarDataCompleta = (data) => {
        if (!data) return '-';
        const d = new Date(data);
        const dia = String(d.getDate()).padStart(2, '0');
        const mes = String(d.getMonth() + 1).padStart(2, '0');
        const ano = d.getFullYear();
        const horas = String(d.getHours()).padStart(2, '0');
        const minutos = String(d.getMinutes()).padStart(2, '0');
        return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
    };

    const getDataHoraLocalInput = () => {
        const now = new Date();
        const ano = now.getFullYear();
        const mes = String(now.getMonth() + 1).padStart(2, '0');
        const dia = String(now.getDate()).padStart(2, '0');
        const horas = String(now.getHours()).padStart(2, '0');
        const minutos = String(now.getMinutes()).padStart(2, '0');
        return `${ano}-${mes}-${dia}T${horas}:${minutos}`;
    };

    const getNomeFornecedor = (fornecedor) => {
        if (!fornecedor) return '-';
        if (typeof fornecedor === 'object' && fornecedor.nome) {
            return fornecedor.nome;
        }
        if (typeof fornecedor === 'string') {
            const encontrado = fornecedores.find(f => f._id === fornecedor || f.id === fornecedor);
            return encontrado ? encontrado.nome : fornecedor;
        }
        return '-';
    };

    const getNomeArmazem = (armazemId) => {
        if (!armazemId) return '-';
        const armazem = armazens.find(a => a._id === armazemId);
        return armazem ? armazem.nome : 'Armazém não encontrado';
    };

    const ordenarProdutos = (lista) => {
        return [...lista].sort((a, b) => {
            const dataA = a.createdAt ? new Date(a.createdAt) : new Date(0);
            const dataB = b.createdAt ? new Date(b.createdAt) : new Date(0);
            return dataB.getTime() - dataA.getTime();
        });
    };

    const ordenarEntradas = (lista) => {
        if (!lista || lista.length === 0) return [];

        const listaOrdenada = [...lista].sort((a, b) => {
            let dataA = a.dataEntrada ? new Date(a.dataEntrada) : null;
            let dataB = b.dataEntrada ? new Date(b.dataEntrada) : null;

            if (!dataA || isNaN(dataA.getTime())) {
                dataA = a.criadoEm ? new Date(a.criadoEm) : (a.createdAt ? new Date(a.createdAt) : new Date(0));
            }
            if (!dataB || isNaN(dataB.getTime())) {
                dataB = b.criadoEm ? new Date(b.criadoEm) : (b.createdAt ? new Date(b.createdAt) : new Date(0));
            }

            const timeA = (dataA && !isNaN(dataA.getTime())) ? dataA.getTime() : 0;
            const timeB = (dataB && !isNaN(dataB.getTime())) ? dataB.getTime() : 0;

            return timeB - timeA;
        });

        return listaOrdenada;
    };

    // ==============================================
    // FUNÇÃO PARA GERAR NÚMEROS DE PÁGINA COM "..."
    // ==============================================
    const getPageNumbers = (currentPage, totalPages) => {
        const pages = [];

        // Se tiver 5 ou menos páginas, mostra todas
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
            return pages;
        }

        // Sempre mostra a página 1
        pages.push(1);

        // Calcula o intervalo de páginas ao redor da página atual
        let startPage = Math.max(2, currentPage - 1);
        let endPage = Math.min(totalPages - 1, currentPage + 1);

        // Ajusta para mostrar 2 páginas no início quando estiver perto do início
        if (currentPage <= 3) {
            startPage = 2;
            endPage = Math.min(totalPages - 1, 4);
        }

        // Ajusta para mostrar 2 páginas no final quando estiver perto do final
        if (currentPage >= totalPages - 2) {
            startPage = Math.max(2, totalPages - 3);
            endPage = totalPages - 1;
        }

        // Adiciona "..." se necessário antes das páginas do meio
        if (startPage > 2) {
            pages.push('...');
        }

        // Adiciona as páginas do meio
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        // Adiciona "..." se necessário depois das páginas do meio
        if (endPage < totalPages - 1) {
            pages.push('...');
        }

        // Sempre mostra a última página
        pages.push(totalPages);

        return pages;
    };
    // ==============================================
    // BUSCAR DADOS
    // ==============================================
    const fetchProdutos = async () => {
        try {
            const response = await api.get('/produtos');
            let produtosData = [];
            if (response.data) {
                if (response.data.data && Array.isArray(response.data.data)) {
                    produtosData = response.data.data;
                } else if (Array.isArray(response.data)) {
                    produtosData = response.data;
                }
            }
            const ativos = produtosData.filter(p => p.ativo !== false);

            const produtosOrdenados = ordenarProdutos(ativos);

            setProdutos(produtosOrdenados);
            setFilteredProdutos(produtosOrdenados);

            setProdutosPagination(prev => ({
                ...prev,
                total: produtosOrdenados.length,
                pages: Math.ceil(produtosOrdenados.length / prev.limit),
                page: 1
            }));
        } catch (err) {
            console.error('❌ Erro ao carregar produtos:', err);
            showToast('Erro ao carregar produtos', 'danger');
        }
    };

    const fetchFornecedores = async () => {
        try {
            const response = await api.get('/fornecedores');
            if (response.data) {
                const fornecedoresData = Array.isArray(response.data) ? response.data : response.data.data || [];
                setFornecedores(fornecedoresData);
            }
        } catch (err) {
            console.error('❌ Erro ao carregar fornecedores:', err);
        }
    };

    const fetchArmazens = async () => {
        try {
            console.log('🔍 Buscando armazéns para EntradaStock...');
            const response = await api.get('/armazens');

            if (response.data && response.data.success) {
                const armazensData = response.data.data || [];
                setArmazens(armazensData);
                console.log('🏢 Armazéns carregados:', armazensData.length);
            } else {
                console.warn('⚠️ Resposta da API sem dados de armazéns:', response.data);
                setArmazens([]);
            }
        } catch (err) {
            console.error('❌ Erro ao carregar armazéns:', err);
            setArmazens([]);
        }
    };

    const fetchEntradas = async (resetPage = true) => {
        setLoadingEntradas(true);
        try {
            const response = await api.get('/produtos/entradas');
            if (response.data) {
                let entradasData = Array.isArray(response.data) ? response.data : response.data.data || [];

                entradasData = entradasData.map(entrada => {
                    if (entrada.produtoId && entrada.produtoId._id) {
                        const produto = produtos.find(p => p._id === entrada.produtoId._id);
                        if (produto) {
                            const produtoArmazemId = produto.armazemId ?
                                (typeof produto.armazemId === 'object' ? produto.armazemId._id : produto.armazemId) :
                                null;

                            if (!entrada.armazemId && produtoArmazemId) {
                                return {
                                    ...entrada,
                                    armazemId: produtoArmazemId
                                };
                            }
                        }
                    }
                    return entrada;
                });

                entradasData = ordenarEntradas(entradasData);
                setEntradas(entradasData);
                calcularStats(entradasData);

                const total = entradasData.length;
                const pages = Math.ceil(total / pagination.limit);

                const novaPagina = resetPage ? 1 : Math.min(pagination.page, pages);

                setPagination({
                    ...pagination,
                    total: total,
                    pages: pages,
                    page: novaPagina
                });
            }
        } catch (err) {
            console.error('❌ Erro ao carregar entradas:', err);
            showToast('Erro ao carregar entradas', 'danger');
        } finally {
            setLoadingEntradas(false);
        }
    };

    const calcularStats = (entradasData) => {
        const total = entradasData.length;
        const totalQuantidade = entradasData.reduce((sum, e) => sum + (e.quantidade || 0), 0);
        const valorTotal = entradasData.reduce((sum, e) => sum + ((e.quantidade || 0) * (e.precoUnitario || 0)), 0);
        const ultimaEntrada = entradasData.length > 0 ? entradasData[0] : null;

        setStats({
            totalEntradas: total,
            totalQuantidade,
            valorTotal,
            ultimaEntrada
        });
    };

    // ==============================================
    // CARREGAR DADOS INICIAIS
    // ==============================================
    useEffect(() => {
        const carregarDados = async () => {
            await fetchProdutos();
            await Promise.all([
                fetchFornecedores(),
                fetchArmazens(),
                fetchEntradas(true)
            ]);
            setLoading(false);
        };
        carregarDados();
    }, []);

    useEffect(() => {
        if (produtos.length > 0 && !loading) {
            fetchEntradas(false);
        }
    }, [produtos]);

    useEffect(() => {
        const dataHoraLocal = getDataHoraLocalInput();
        setFormData(prev => ({
            ...prev,
            dataEntrada: dataHoraLocal
        }));
    }, []);

    useEffect(() => {
        let filtered;
        if (searchTerm.trim() === '') {
            filtered = produtos;
        } else {
            const term = searchTerm.toLowerCase().trim();
            filtered = produtos.filter(p =>
                p.nome.toLowerCase().includes(term) ||
                (p.codigo && p.codigo.toLowerCase().includes(term)) ||
                (p.categoriaId?.nome && p.categoriaId.nome.toLowerCase().includes(term))
            );
        }
        setFilteredProdutos(filtered);
        setProdutosPagination(prev => ({
            ...prev,
            total: filtered.length,
            pages: Math.ceil(filtered.length / prev.limit),
            page: 1
        }));
    }, [searchTerm, produtos]);

    useEffect(() => {
        if (searchProdutoPopup.trim() === '') {
            setProdutosFiltradosPopup([]);
            return;
        }

        const term = searchProdutoPopup.toLowerCase().trim();
        const filtered = produtos.filter(p =>
            p.nome.toLowerCase().includes(term) ||
            (p.codigo && p.codigo.toLowerCase().includes(term))
        );
        setProdutosFiltradosPopup(filtered.slice(0, 10));
    }, [searchProdutoPopup, produtos]);

    useEffect(() => {
        if (searchProdutoSaida.trim() === '') {
            setProdutosFiltradosSaida([]);
            return;
        }

        const term = searchProdutoSaida.toLowerCase().trim();
        const filtered = produtos.filter(p =>
            p.nome.toLowerCase().includes(term) ||
            (p.codigo && p.codigo.toLowerCase().includes(term))
        );
        setProdutosFiltradosSaida(filtered.slice(0, 10));
    }, [searchProdutoSaida, produtos]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
            if (dropdownSaidaRef.current && !dropdownSaidaRef.current.contains(event.target)) {
                setShowDropdownSaida(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const total = historicoProduto.length;
        const pages = Math.ceil(total / historicoPagination.limit) || 1;
        setHistoricoPagination(prev => ({
            ...prev,
            total: total,
            pages: pages,
            page: prev.page > pages ? 1 : prev.page
        }));
    }, [historicoProduto]);

    // ==============================================
    // HANDLE CHANGE
    // ==============================================
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSaidaChange = (e) => {
        const { name, value } = e.target;
        setSaidaFormData(prev => ({ ...prev, [name]: value }));
    };

    // ==============================================
    // SELECIONAR PRODUTO
    // ==============================================
    const selecionarProdutoPopup = (produto) => {
        if (!produto) return;
        setProdutoSelecionado(produto);
        setSearchProdutoPopup(produto.nome);
        setShowDropdown(false);

        let fornecedorId = '';
        if (produto.fornecedorId) {
            if (typeof produto.fornecedorId === 'object' && produto.fornecedorId._id) {
                fornecedorId = produto.fornecedorId._id;
            } else if (typeof produto.fornecedorId === 'string') {
                fornecedorId = produto.fornecedorId;
            } else if (typeof produto.fornecedorId === 'object' && produto.fornecedorId.id) {
                fornecedorId = produto.fornecedorId.id;
            }
        }

        setFormData(prev => ({
            ...prev,
            produtoId: produto._id,
            precoUnitario: produto.precoCompra || 0,
            fornecedorId: fornecedorId
        }));
    };

    const selecionarProdutoSaida = (produto) => {
        if (!produto) return;
        setProdutoSelecionado(produto);
        setSearchProdutoSaida(produto.nome);
        setShowDropdownSaida(false);

        setSaidaFormData(prev => ({
            ...prev,
            produtoId: produto._id
        }));
    };

    const limparSelecao = () => {
        setProdutoSelecionado(null);
        setSearchProdutoPopup('');
        setFormData(prev => ({
            ...prev,
            produtoId: '',
            precoUnitario: 0,
            fornecedorId: ''
        }));
    };

    const limparSelecaoSaida = () => {
        setProdutoSelecionado(null);
        setSearchProdutoSaida('');
        setSaidaFormData(prev => ({
            ...prev,
            produtoId: ''
        }));
    };

    const openEntradaModal = (produto = null) => {
        if (produto) {
            selecionarProdutoPopup(produto);
        } else {
            setProdutoSelecionado(null);
            setSearchProdutoPopup('');
            setFormData({
                produtoId: '',
                quantidade: 1,
                precoUnitario: 0,
                fornecedorId: '',
                notaFiscal: '',
                dataEntrada: getDataHoraLocalInput(),
                observacao: ''
            });
        }
        setShowEntradaModal(true);
        setTimeout(() => setShowDropdown(false), 100);
    };

    const openSaidaModal = (produto = null) => {
        if (produto) {
            setProdutoSelecionado(produto);
            setSearchProdutoSaida(produto.nome);
            setSaidaFormData({
                produtoId: produto._id,
                quantidade: 1,
                observacao: ''
            });
        } else {
            setProdutoSelecionado(null);
            setSearchProdutoSaida('');
            setSaidaFormData({
                produtoId: '',
                quantidade: 1,
                observacao: ''
            });
        }
        setShowSaidaModal(true);
        setTimeout(() => setShowDropdownSaida(false), 100);
    };

    const closeEntradaModal = () => {
        setShowEntradaModal(false);
        setProdutoSelecionado(null);
        setSearchProdutoPopup('');
        setShowDropdown(false);
        setFormData({
            produtoId: '',
            quantidade: 1,
            precoUnitario: 0,
            fornecedorId: '',
            notaFiscal: '',
            dataEntrada: getDataHoraLocalInput(),
            observacao: ''
        });
    };

    const closeSaidaModal = () => {
        setShowSaidaModal(false);
        setProdutoSelecionado(null);
        setSearchProdutoSaida('');
        setShowDropdownSaida(false);
        setSaidaFormData({
            produtoId: '',
            quantidade: 1,
            observacao: ''
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        if (!formData.produtoId) {
            showToast('Selecione um produto', 'danger');
            setSubmitting(false);
            return;
        }

        if (!formData.quantidade || formData.quantidade <= 0) {
            showToast('Quantidade inválida', 'danger');
            setSubmitting(false);
            return;
        }

        if (!formData.precoUnitario || formData.precoUnitario <= 0) {
            showToast('Preço unitário inválido', 'danger');
            setSubmitting(false);
            return;
        }

        try {
            const dadosEnvio = {
                produtoId: formData.produtoId,
                quantidade: parseInt(formData.quantidade),
                precoUnitario: parseFloat(formData.precoUnitario),
                fornecedorId: formData.fornecedorId || null,
                notaFiscal: formData.notaFiscal || null,
                dataEntrada: formData.dataEntrada,
                observacao: formData.observacao || null
            };

            const response = await api.post('/produtos/entradas', dadosEnvio);

            if (response.data) {
                showToast('Entrada de stock registada com sucesso!', 'success');
                closeEntradaModal();
                await fetchEntradas(true);
                await fetchProdutos();
            }
        } catch (err) {
            console.error('❌ Erro ao registrar entrada:', err);
            showToast(
                err.response?.data?.erro || err.response?.data?.mensagem || 'Erro ao registrar entrada',
                'danger'
            );
        } finally {
            setSubmitting(false);
        }
    };

    const handleSaidaSubmit = async (e) => {
        e.preventDefault();
        setSubmittingSaida(true);

        if (!saidaFormData.produtoId) {
            showToast('Selecione um produto', 'danger');
            setSubmittingSaida(false);
            return;
        }

        if (!saidaFormData.quantidade || saidaFormData.quantidade <= 0) {
            showToast('Quantidade inválida', 'danger');
            setSubmittingSaida(false);
            return;
        }

        try {
            const dadosEnvio = {
                quantidade: parseInt(saidaFormData.quantidade),
                observacao: saidaFormData.observacao || null
            };

            const response = await api.post(
                `/produtos/${saidaFormData.produtoId}/saida-stock`,
                dadosEnvio
            );

            if (response.data) {
                showToast('Saída de stock registada com sucesso!', 'success');
                closeSaidaModal();
                await fetchEntradas(true);
                await fetchProdutos();
            }
        } catch (err) {
            console.error('❌ Erro ao registrar saída:', err);

            if (err.response?.data?.stockDisponivel !== undefined) {
                showToast(
                    `Stock insuficiente! Disponível: ${err.response.data.stockDisponivel} unidades`,
                    'danger'
                );
            } else {
                showToast(
                    err.response?.data?.erro || err.response?.data?.mensagem || 'Erro ao registrar saída',
                    'danger'
                );
            }
        } finally {
            setSubmittingSaida(false);
        }
    };

    const verDetalhesEntrada = async (entrada) => {
        try {
            const response = await api.get(`/produtos/entradas/${entrada._id}`);
            setEntradaSelecionada(response.data.data || entrada);
            setShowDetalhesModal(true);
        } catch (err) {
            console.error('❌ Erro ao buscar detalhes:', err);
            setEntradaSelecionada(entrada);
            setShowDetalhesModal(true);
        }
    };

    const verHistoricoProduto = async (produto) => {
        setLoadingHistorico(true);
        try {
            const response = await api.get(`/produtos/${produto._id}/entradas`);
            setProdutoSelecionado(produto);
            let historicoData = response.data.data || [];

            historicoData = historicoData.map(entry => {
                if (!entry.armazemId && produto) {
                    const produtoArmazemId = produto.armazemId ?
                        (typeof produto.armazemId === 'object' ? produto.armazemId._id : produto.armazemId) :
                        null;
                    return {
                        ...entry,
                        armazemId: produtoArmazemId || null
                    };
                }
                return entry;
            });

            historicoData = ordenarEntradas(historicoData);
            setHistoricoProduto(historicoData);

            setHistoricoPagination(prev => ({
                ...prev,
                page: 1
            }));

            setShowHistoricoModal(true);
        } catch (err) {
            console.error('❌ Erro ao buscar histórico:', err);
            showToast('Erro ao carregar histórico', 'danger');
        } finally {
            setLoadingHistorico(false);
        }
    };



    // ==============================================
    // PAGINAÇÃO
    // ==============================================
    const getCurrentPageHistorico = () => {
        const startIndex = (historicoPagination.page - 1) * historicoPagination.limit;
        const endIndex = startIndex + historicoPagination.limit;
        return historicoProduto.slice(startIndex, endIndex);
    };

    const goToHistoricoPage = (page) => {
        if (page < 1 || page > historicoPagination.pages) return;
        setHistoricoPagination(prev => ({ ...prev, page }));
    };

    const renderHistoricoPagination = () => {
        const { page, pages, total, limit } = historicoPagination;
        if (pages <= 1) return null;

        const startItem = (page - 1) * limit + 1;
        const endItem = Math.min(page * limit, total);
        const pageNumbers = getPageNumbers(page, pages);

        return (
            <div className="historico-pagination">
                <div className="pagination-info">
                    <span>Mostrando {startItem} - {endItem} de {total} registos</span>
                </div>
                <div className="pagination-controls">
                    <button
                        className="pagination-btn"
                        onClick={() => goToHistoricoPage(page - 1)}
                        disabled={page === 1}
                    >
                        <Icon name="chevron_left" size={16} />
                    </button>
                    <div className="pagination-numbers">
                        {pageNumbers.map((p, index) => {
                            if (p === '...') {
                                return (
                                    <span key={`dots-${index}`} className="pagination-dots">
                                        …
                                    </span>
                                );
                            }
                            return (
                                <button
                                    key={p}
                                    className={`pagination-number ${page === p ? 'active' : ''}`}
                                    onClick={() => goToHistoricoPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        })}
                    </div>
                    <button
                        className="pagination-btn"
                        onClick={() => goToHistoricoPage(page + 1)}
                        disabled={page === pages}
                    >
                        <Icon name="chevron_right" size={16} />
                    </button>
                </div>
            </div>
        );
    };

    const getCurrentPageEntradas = () => {
        const startIndex = (pagination.page - 1) * pagination.limit;
        const endIndex = startIndex + pagination.limit;
        return entradas.slice(startIndex, endIndex);
    };

    const goToPage = (page) => {
        if (page < 1 || page > pagination.pages) return;
        setPagination({ ...pagination, page });
    };

    const renderPagination = () => {
        const { page, pages, total } = pagination;
        if (pages <= 1) return null;

        const startItem = (page - 1) * pagination.limit + 1;
        const endItem = Math.min(page * pagination.limit, total);
        const pageNumbers = getPageNumbers(page, pages);

        return (
            <div className="entrada-pagination">
                <div className="pagination-info">
                    <span>Mostrando {startItem} - {endItem} de {total} registos</span>
                </div>
                <div className="pagination-controls">
                    <button className="pagination-btn" onClick={() => goToPage(page - 1)} disabled={page === 1}>
                        <Icon name="chevron_left" size={18} />
                    </button>
                    <div className="pagination-numbers">
                        {pageNumbers.map((p, index) => {
                            if (p === '...') {
                                return (
                                    <span key={`dots-${index}`} className="pagination-dots">
                                        …
                                    </span>
                                );
                            }
                            return (
                                <button
                                    key={p}
                                    className={`pagination-number ${page === p ? 'active' : ''}`}
                                    onClick={() => goToPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        })}
                    </div>
                    <button className="pagination-btn" onClick={() => goToPage(page + 1)} disabled={page === pages}>
                        <Icon name="chevron_right" size={18} />
                    </button>
                </div>
            </div>
        );
    };

    const getCurrentPageProdutos = () => {
        const startIndex = (produtosPagination.page - 1) * produtosPagination.limit;
        const endIndex = startIndex + produtosPagination.limit;
        return filteredProdutos.slice(startIndex, endIndex);
    };

    const goToProdutosPage = (page) => {
        if (page < 1 || page > produtosPagination.pages) return;
        setProdutosPagination({ ...produtosPagination, page });
    };

    const renderProdutosPagination = () => {
        const { page, pages, total } = produtosPagination;
        if (pages <= 1) return null;

        const startItem = (page - 1) * produtosPagination.limit + 1;
        const endItem = Math.min(page * produtosPagination.limit, total);
        const pageNumbers = getPageNumbers(page, pages);

        return (
            <div className="entrada-pagination">
                <div className="pagination-info">
                    <span>Mostrando {startItem} - {endItem} de {total} produtos</span>
                </div>
                <div className="pagination-controls">
                    <button className="pagination-btn" onClick={() => goToProdutosPage(page - 1)} disabled={page === 1}>
                        <Icon name="chevron_left" size={18} />
                    </button>
                    <div className="pagination-numbers">
                        {pageNumbers.map((p, index) => {
                            if (p === '...') {
                                return (
                                    <span key={`dots-${index}`} className="pagination-dots">
                                        …
                                    </span>
                                );
                            }
                            return (
                                <button
                                    key={p}
                                    className={`pagination-number ${page === p ? 'active' : ''}`}
                                    onClick={() => goToProdutosPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        })}
                    </div>
                    <button className="pagination-btn" onClick={() => goToProdutosPage(page + 1)} disabled={page === pages}>
                        <Icon name="chevron_right" size={18} />
                    </button>
                </div>
            </div>
        );
    };

    const currentEntradas = getCurrentPageEntradas();
    const currentProdutos = getCurrentPageProdutos();
    const currentHistorico = getCurrentPageHistorico();

    // ==============================================
    // RENDER PRINCIPAL
    // ==============================================
    return (
        <div className="entrada-stock-container">
            {/* MENSAGENS */}
            {message.text && (
                <div className={`alert alert-${message.type}`}>
                    <Icon name={message.type === 'success' ? 'check_circle' : 'error'} size={16} />
                    <span>{message.text}</span>
                    <button className="alert-close" onClick={() => setMessage({ text: '', type: '' })}>×</button>
                </div>
            )}

            {/* MODAL DE ENTRADA */}
{showEntradaModal && (
    <div className="stock-modal-overlay" onClick={closeEntradaModal}>
        <div className="stock-modal-content stock-modal-entrada" onClick={(e) => e.stopPropagation()}>
            <div className="stock-modal-header">
                <h3>
                    <Icon name="add_box" size={22} />
                    {produtoSelecionado ? `Adicionar Stock - ${produtoSelecionado.nome}` : 'Nova Entrada de Stock'}
                </h3>
                <button className="stock-modal-close" onClick={closeEntradaModal}>×</button>
            </div>
            <div className="stock-modal-body">
                <form onSubmit={handleSubmit}>
                    <div className="stock-form-group">
                        <label>Produto <span className="stock-required">*</span></label>
                        <div className="stock-produto-search-container" ref={dropdownRef}>
                            <div className="stock-produto-search-input-wrapper">
                                <Icon name="search" size={18} className="stock-search-icon" />
                                <input
                                    type="text"
                                    placeholder="Pesquisar produto por nome ou código..."
                                    value={searchProdutoPopup}
                                    onChange={(e) => {
                                        setSearchProdutoPopup(e.target.value);
                                        setShowDropdown(true);
                                        if (e.target.value === '') {
                                            limparSelecao();
                                        }
                                    }}
                                    onFocus={() => {
                                        if (searchProdutoPopup.trim() !== '') {
                                            setShowDropdown(true);
                                        }
                                    }}
                                    className="stock-produto-search-input"
                                />
                                {produtoSelecionado && (
                                    <button
                                        type="button"
                                        className="stock-produto-clear-btn"
                                        onClick={limparSelecao}
                                        title="Limpar seleção"
                                    >
                                        <Icon name="close" size={16} />
                                    </button>
                                )}
                            </div>

                            {showDropdown && produtosFiltradosPopup.length > 0 && (
                                <div className="stock-produto-dropdown">
                                    {produtosFiltradosPopup.map(produto => {
                                        if (!produto) return null;
                                        const armazemNome = getNomeArmazem(
                                            typeof produto.armazemId === 'object'
                                                ? produto.armazemId?._id
                                                : produto.armazemId
                                        );

                                        return (
                                            <div
                                                key={produto._id}
                                                className="stock-produto-dropdown-item"
                                                onClick={() => selecionarProdutoPopup(produto)}
                                            >
                                                <div className="stock-produto-dropdown-info">
                                                    <span className="stock-produto-dropdown-nome">{produto.nome}</span>
                                                    {produto.codigo && (
                                                        <span className="stock-produto-dropdown-codigo">Cód: {produto.codigo}</span>
                                                    )}
                                                    {armazemNome && armazemNome !== '-' && (
                                                        <span className="stock-produto-dropdown-armazem">
                                                            <Icon name="store" size={12} />
                                                            {armazemNome}
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="stock-produto-dropdown-stock">
                                                    <span className={`stock-badge ${produto.stockAtual > 0 ? 'stock-badge-alto' : 'stock-badge-sem'}`}>
                                                        Stock: {produto.stockAtual || 0}
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {showDropdown && searchProdutoPopup.trim() !== '' && produtosFiltradosPopup.length === 0 && (
                                <div className="stock-produto-dropdown stock-empty">
                                    <span>Nenhum produto encontrado</span>
                                </div>
                            )}
                        </div>

                        {/* 🔥 PRODUTO SELECIONADO COM ARMAZÉM - ENTRADA */}
                        {produtoSelecionado && (
                            <div className="stock-produto-selecionado-info stock-entrada">
                                <span className="stock-produto-nome">{produtoSelecionado.nome}</span>
                                <span className="stock-produto-codigo">Cód: {produtoSelecionado.codigo || '-'}</span>
                                {(() => {
                                    const armazemNome = getNomeArmazem(
                                        typeof produtoSelecionado.armazemId === 'object'
                                            ? produtoSelecionado.armazemId?._id
                                            : produtoSelecionado.armazemId
                                    );
                                    return armazemNome && armazemNome !== '-' ? (
                                        <span className="stock-produto-armazem-selecionado">
                                            <Icon name="store" size={12} />
                                            {armazemNome}
                                        </span>
                                    ) : null;
                                })()}
                                <span className="stock-produto-stock-atual">
                                    Stock atual: {produtoSelecionado.stockAtual || 0}
                                </span>
                            </div>
                        )}
                    </div>

                    <div className="stock-form-row">
                        <div className="stock-form-group">
                            <label>Quantidade <span className="stock-required">*</span></label>
                            <input
                                type="number"
                                name="quantidade"
                                value={formData.quantidade}
                                onChange={handleChange}
                                min="1"
                                step="1"
                                required
                                placeholder="1"
                            />
                        </div>
                        <div className="stock-form-group">
                            <label>Preço Unitário <span className="stock-required">*</span></label>
                            <input
                                type="number"
                                name="precoUnitario"
                                value={formData.precoUnitario}
                                onChange={handleChange}
                                min="0.01"
                                step="0.01"
                                required
                                placeholder="0.00"
                            />
                        </div>
                    </div>

                    <div className="stock-form-row">
                        <div className="stock-form-group">
                            <label>Fornecedor</label>
                            <select
                                name="fornecedorId"
                                value={formData.fornecedorId}
                                onChange={handleChange}
                            >
                                <option value="">Selecione um fornecedor</option>
                                {fornecedores.map(f => (
                                    <option key={f._id} value={f._id}>{f.nome}</option>
                                ))}
                            </select>
                        </div>
                        <div className="stock-form-group">
                            <label>Data da Entrada</label>
                            <input
                                type="datetime-local"
                                name="dataEntrada"
                                value={formData.dataEntrada}
                                onChange={handleChange}
                                step="60"
                            />
                        </div>
                    </div>

                    <div className="stock-form-group">
                        <label>Nº Nota Fiscal</label>
                        <input
                            type="text"
                            name="notaFiscal"
                            value={formData.notaFiscal}
                            onChange={handleChange}
                            placeholder="Número da nota fiscal (opcional)"
                        />
                    </div>

                    <div className="stock-form-group">
                        <label>Observação</label>
                        <textarea
                            name="observacao"
                            value={formData.observacao}
                            onChange={handleChange}
                            placeholder="Observações adicionais (opcional)"
                            rows="2"
                        />
                    </div>

                    <div className="stock-modal-actions-footer stock-footer-entrada">
                        <button type="submit" className="stock-modal-btn-primary" disabled={submitting}>
                            {submitting ? 'A processar...' : 'Registrar Entrada'}
                        </button>
                        <button type="button" className="stock-modal-btn-secondary" onClick={closeEntradaModal}>
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
)}

{/* MODAL DE SAÍDA */}
{showSaidaModal && (
    <div className="stock-modal-overlay" onClick={closeSaidaModal}>
        <div className="stock-modal-content stock-modal-saida" onClick={(e) => e.stopPropagation()}>
            <div className="stock-modal-header">
                <h3>
                    <Icon name="remove_box" size={22} />
                    {produtoSelecionado ? `Remover Stock - ${produtoSelecionado.nome}` : 'Nova Saída de Stock'}
                </h3>
                <button className="stock-modal-close" onClick={closeSaidaModal}>×</button>
            </div>
            <div className="stock-modal-body">
                <form onSubmit={handleSaidaSubmit}>
                    <div className="stock-form-group">
                        <label>Produto <span className="stock-required">*</span></label>
                        <div className="stock-produto-search-container" ref={dropdownSaidaRef}>
                            <div className="stock-produto-search-input-wrapper">
                                <Icon name="search" size={18} className="stock-search-icon" />
                                <input
                                    type="text"
                                    placeholder="Pesquisar produto por nome ou código..."
                                    value={searchProdutoSaida}
                                    onChange={(e) => {
                                        setSearchProdutoSaida(e.target.value);
                                        setShowDropdownSaida(true);
                                        if (e.target.value === '') {
                                            limparSelecaoSaida();
                                        }
                                    }}
                                    onFocus={() => {
                                        if (searchProdutoSaida.trim() !== '') {
                                            setShowDropdownSaida(true);
                                        }
                                    }}
                                    className="stock-produto-search-input"
                                />
                                {produtoSelecionado && (
                                    <button
                                        type="button"
                                        className="stock-produto-clear-btn"
                                        onClick={limparSelecaoSaida}
                                        title="Limpar seleção"
                                    >
                                        <Icon name="close" size={16} />
                                    </button>
                                )}
                            </div>

                            {showDropdownSaida && produtosFiltradosSaida.length > 0 && (
                                <div className="stock-produto-dropdown">
                                    {produtosFiltradosSaida.map(produto => {
                                        if (!produto) return null;
                                        const armazemNome = getNomeArmazem(
                                            typeof produto.armazemId === 'object'
                                                ? produto.armazemId?._id
                                                : produto.armazemId
                                        );

                                        return (
                                            <div
                                                key={produto._id}
                                                className="stock-produto-dropdown-item"
                                                onClick={() => selecionarProdutoSaida(produto)}
                                            >
                                                <div className="stock-produto-dropdown-info">
                                                    <span className="stock-produto-dropdown-nome">{produto.nome}</span>
                                                    {produto.codigo && (
                                                        <span className="stock-produto-dropdown-codigo">Cód: {produto.codigo}</span>
                                                    )}
                                                    {armazemNome && armazemNome !== '-' && (
                                                        <span className="stock-produto-dropdown-armazem">
                                                            <Icon name="store" size={12} />
                                                            {armazemNome}
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="stock-produto-dropdown-stock">
                                                    <span className={`stock-badge ${produto.stockAtual > 0 ? 'stock-badge-alto' : 'stock-badge-sem'}`}>
                                                        Stock: {produto.stockAtual || 0}
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {showDropdownSaida && searchProdutoSaida.trim() !== '' && produtosFiltradosSaida.length === 0 && (
                                <div className="stock-produto-dropdown stock-empty">
                                    <span>Nenhum produto encontrado</span>
                                </div>
                            )}
                        </div>

                        {/* 🔥 PRODUTO SELECIONADO COM ARMAZÉM - SAÍDA (VERMELHO) */}
                        {produtoSelecionado && (
                            <div className="stock-produto-selecionado-info stock-saida">
                                <span className="stock-produto-nome">{produtoSelecionado.nome}</span>
                                <span className="stock-produto-codigo">Cód: {produtoSelecionado.codigo || '-'}</span>
                                {(() => {
                                    const armazemNome = getNomeArmazem(
                                        typeof produtoSelecionado.armazemId === 'object'
                                            ? produtoSelecionado.armazemId?._id
                                            : produtoSelecionado.armazemId
                                    );
                                    return armazemNome && armazemNome !== '-' ? (
                                        <span className="stock-produto-armazem-selecionado stock-saida">
                                            <Icon name="store" size={12} />
                                            {armazemNome}
                                        </span>
                                    ) : null;
                                })()}
                                <span className="stock-produto-stock-atual" style={{ color: '#dc2626' }}>
                                    Stock atual: {produtoSelecionado.stockAtual || 0}
                                </span>
                            </div>
                        )}
                    </div>

                    <div className="stock-form-group">
                        <label>Quantidade a Remover <span className="stock-required">*</span></label>
                        <input
                            type="number"
                            name="quantidade"
                            value={saidaFormData.quantidade}
                            onChange={handleSaidaChange}
                            min="1"
                            step="1"
                            required
                            placeholder="1"
                        />
                        {produtoSelecionado && (
                            <small className="stock-form-help">
                                Stock disponível: {produtoSelecionado.stockAtual || 0} unidades
                            </small>
                        )}
                    </div>

                    <div className="stock-form-group">
                        <label>Observação</label>
                        <textarea
                            name="observacao"
                            value={saidaFormData.observacao}
                            onChange={handleSaidaChange}
                            placeholder="Motivo da saída (opcional)"
                            rows="2"
                        />
                    </div>

                    <div className="stock-modal-actions-footer stock-footer-saida">
                        <button type="submit" className="stock-modal-btn-danger" disabled={submittingSaida}>
                            {submittingSaida ? 'A processar...' : 'Registrar Saída'}
                        </button>
                        <button type="button" className="stock-modal-btn-secondary" onClick={closeSaidaModal}>
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
)}

{/* MODAL DE DETALHES DA ENTRADA - COM ARMAZÉM */}
{showDetalhesModal && entradaSelecionada && (
    <div className="stock-modal-overlay" onClick={() => setShowDetalhesModal(false)}>
        <div className="stock-modal-content stock-modal-detalhes" onClick={(e) => e.stopPropagation()}>
            <div className="stock-modal-header">
                <h3>
                    <Icon name="receipt_long" size={22} />
                    Detalhes da Movimentação
                </h3>
                <button className="stock-modal-close" onClick={() => setShowDetalhesModal(false)}>×</button>
            </div>
            <div className="stock-modal-body stock-detalhes-body">
                <div className="stock-detalhes-grid">
                    <div className="stock-info-item">
                        <span className="stock-label">📦 Produto</span>
                        <span className="stock-value">{entradaSelecionada.produtoId?.nome || 'N/A'}</span>
                    </div>
                    <div className="stock-info-item">
                        <span className="stock-label">📝 Código</span>
                        <span className="stock-value">{entradaSelecionada.produtoId?.codigo || '-'}</span>
                    </div>
                    <div className="stock-info-item">
                        <span className="stock-label">🔢 Quantidade</span>
                        <span className="stock-value">{entradaSelecionada.quantidade}</span>
                    </div>
                    <div className="stock-info-item">
                        <span className="stock-label">💰 Preço Unitário</span>
                        <span className="stock-value">{formatarMoeda(entradaSelecionada.precoUnitario)}</span>
                    </div>
                    <div className="stock-info-item">
                        <span className="stock-label">💵 Valor Total</span>
                        <span className="stock-value stock-valor-total">
                            {formatarMoeda(entradaSelecionada.quantidade * entradaSelecionada.precoUnitario)}
                        </span>
                    </div>
                    <div className="stock-info-item">
                        <span className="stock-label">🏢 Fornecedor</span>
                        <span className="stock-value">{getNomeFornecedor(entradaSelecionada.fornecedorId)}</span>
                    </div>
                    <div className="stock-info-item">
                        <span className="stock-label">🏪 Armazém</span>
                        <span className="stock-value">
                            {getNomeArmazem(entradaSelecionada.armazemId)}
                        </span>
                    </div>
                    <div className="stock-info-item">
                        <span className="stock-label">📅 Data/Hora</span>
                        <span className="stock-value">{formatarDataCompleta(entradaSelecionada.dataEntrada)}</span>
                    </div>
                    <div className="stock-info-item">
                        <span className="stock-label">📄 Nota Fiscal</span>
                        <span className="stock-value">{entradaSelecionada.notaFiscal || '-'}</span>
                    </div>
                </div>
                {entradaSelecionada.observacao && (
                    <div className="stock-observacao-container">
                        <h4>📝 Observação</h4>
                        <p>{entradaSelecionada.observacao}</p>
                    </div>
                )}
            </div>
            <div className="stock-modal-footer">
                <button className="stock-btn-secondary" onClick={() => setShowDetalhesModal(false)}>Fechar</button>
            </div>
        </div>
    </div>
)}

{/* MODAL DE HISTÓRICO DO PRODUTO - COM ARMAZÉM */}
{showHistoricoModal && produtoSelecionado && (
    <div className="stock-modal-overlay" onClick={() => setShowHistoricoModal(false)}>
        <div className="stock-modal-content stock-modal-historico stock-modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="stock-modal-header">
                <h3>
                    <Icon name="history" size={22} />
                    Histórico de Movimentos - {produtoSelecionado.nome}
                </h3>
                <button className="stock-modal-close" onClick={() => setShowHistoricoModal(false)}>×</button>
            </div>
            <div className="stock-modal-body stock-historico-body">
                {loadingHistorico ? (
                    <div className="stock-loading-container">
                        <div className="stock-spinner-large"></div>
                        <p>A carregar histórico...</p>
                    </div>
                ) : historicoProduto.length === 0 ? (
                    <div className="stock-empty-state">
                        <Icon name="inventory_2" size={48} />
                        <p>Nenhum movimento registado para este produto</p>
                    </div>
                ) : (
                    <>
                        <div className="stock-historico-timeline">
                            {currentHistorico.map((entry, index) => {
                                const isEntrada = entry.quantidade > 0;
                                const cor = isEntrada ? '#10b981' : '#dc2626';
                                const iconName = isEntrada ? 'add_box' : 'remove_circle';
                                const sinal = isEntrada ? '+' : '-';
                                const quantidadeAbs = Math.abs(entry.quantidade);

                                return (
                                    <div key={entry._id || index} className={`stock-historico-item ${isEntrada ? 'stock-entrada' : 'stock-saida'}`}>
                                        <div className="stock-historico-icon" style={{ background: cor }}>
                                            <Icon name={iconName} size={14} style={{ color: 'white' }} />
                                        </div>
                                        <div className="stock-historico-content">
                                            <div className="stock-historico-header">
                                                <span className="stock-historico-quantidade" style={{ color: cor }}>
                                                    {sinal}{quantidadeAbs} unidades
                                                </span>
                                                <span className="stock-historico-tipo-label">
                                                    {isEntrada ? 'Entrada' : 'Saída'}
                                                </span>
                                                <span className="stock-historico-data">
                                                    {formatarDataCompleta(entry.dataEntrada)}
                                                </span>
                                            </div>
                                            <div className="stock-historico-detalhes">
                                                <span>💰 {formatarMoeda(entry.precoUnitario)}/un</span>
                                                <span>💵 Total: {formatarMoeda(quantidadeAbs * entry.precoUnitario)}</span>
                                                <span>🏢 Fornecedor: {getNomeFornecedor(entry.fornecedorId)}</span>
                                                <span>🏪 Armazém: {getNomeArmazem(entry.armazemId)}</span>
                                                {entry.notaFiscal && (
                                                    <span>📄 NF: {entry.notaFiscal}</span>
                                                )}
                                                {entry.observacao && (
                                                    <span className="stock-historico-observacao">📝 {entry.observacao}</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        {renderHistoricoPagination()}
                    </>
                )}
            </div>
            <div className="stock-modal-footer">
                <button className="stock-btn-secondary" onClick={() => setShowHistoricoModal(false)}>Fechar</button>
            </div>
        </div>
    </div>
)}

            {/* HEADER - COM SÍMBOLOS + E - */}
            <div className="entrada-header">
                <div className="header-title">
                    <h2><Icon name="inventory_2" size={24} /> Gestão de Stock</h2>
                    <p>Registe entradas e saídas de stock</p>
                </div>
                <div className="header-actions">
                    <button className="btn-create entrada" onClick={() => openEntradaModal()}>
                        <span className="btn-icon">+</span> Entrada
                    </button>
                    <button className="btn-create saida" onClick={() => openSaidaModal()}>
                        <span className="btn-icon">−</span> Saída
                    </button>
                </div>
            </div>

            {/* KPIs */}
            <div className="entrada-kpi-grid">
                <div className="kpi-card primary">
                    <div className="kpi-icon"><Icon name="receipt_long" size={16} /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">{stats.totalEntradas}</span>
                        <span className="kpi-label">Total de Entradas</span>
                    </div>
                </div>
                <div className="kpi-card success">
                    <div className="kpi-icon"><Icon name="inventory_2" size={16} /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">{stats.totalQuantidade}</span>
                        <span className="kpi-label">Unidades Adicionadas</span>
                    </div>
                </div>
                <div className="kpi-card info">
                    <div className="kpi-icon"><Icon name="attach_money" size={16} /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">{formatarMoeda(stats.valorTotal)}</span>
                        <span className="kpi-label">Valor Total em Stock</span>
                    </div>
                </div>
                <div className="kpi-card warning">
                    <div className="kpi-icon"><Icon name="history" size={16} /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">
                            {stats.ultimaEntrada ? formatarDataCompleta(stats.ultimaEntrada.dataEntrada) : '-'}
                        </span>
                        <span className="kpi-label">Última Entrada</span>
                    </div>
                </div>
            </div>

            {/* FILTROS E BUSCA */}
            <div className="entrada-filters">
                <div className="search-box">
                    <Icon name="search" size={18} />
                    <input
                        type="text"
                        placeholder="Pesquisar produto por nome ou código..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    {searchTerm && (
                        <button className="search-clear" onClick={() => setSearchTerm('')}>
                            <Icon name="close" size={16} />
                        </button>
                    )}
                </div>
                <button className="btn-refresh" onClick={() => fetchEntradas(true)} title="Atualizar">
                    <Icon name="refresh" size={18} />
                </button>
            </div>

            {/* LISTA DE PRODUTOS COM PAGINAÇÃO */}
            {loading ? (
                <div className="loading-container">
                    <div className="spinner-large"></div>
                    <p>A carregar produtos...</p>
                </div>
            ) : (
                <>
                    <div className="produtos-grid">
                        {currentProdutos.length === 0 ? (
                            <div className="empty-state" style={{ gridColumn: '1 / -1' }}>
                                <Icon name="inventory_2" size={48} />
                                <p>Nenhum produto encontrado</p>
                                <button className="btn-create-small" onClick={() => window.location.href = '/produtos'}>
                                    Ir para Gestão de Produtos
                                </button>
                            </div>
                        ) : (
                            currentProdutos.map(produto => (
                                <div key={produto._id} className="produto-card">
                                    <div className="produto-card-header">
                                        <h4>{produto.nome}</h4>
                                        <span className={`status-badge ${produto.stockAtual > 0 ? 'stock-alto' : 'sem-stock'}`}>
                                            <Icon name={produto.stockAtual > 0 ? 'check_circle' : 'block'} size={12} />
                                            {produto.stockAtual > 0 ? 'Em Stock' : 'Sem Stock'}
                                        </span>
                                    </div>
                                    <div className="produto-card-body">
                                        <div className="produto-info-grid">
                                            <div className="info-item">
                                                <span className="label">Código</span>
                                                <span className="value">{produto.codigo || '-'}</span>
                                            </div>
                                            <div className="info-item">
                                                <span className="label">Categoria</span>
                                                <span className="value">{produto.categoriaId?.nome || '-'}</span>
                                            </div>
                                            <div className="info-item">
                                                <span className="label">Stock Atual</span>
                                                <span className="value" style={{ fontWeight: 700, color: produto.stockAtual > 0 ? '#10b981' : '#dc2626' }}>
                                                    {produto.stockAtual || 0}
                                                </span>
                                            </div>
                                            <div className="info-item">
                                                <span className="label">Preço Compra</span>
                                                <span className="value">{formatarMoeda(produto.precoCompra)}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="produto-card-actions">
                                        <button
                                            className="btn-entrada"
                                            onClick={() => openEntradaModal(produto)}
                                            title="Adicionar stock"
                                        >
                                            <span className="btn-icon">+</span> Entrada
                                        </button>
                                        <button
                                            className="btn-saida"
                                            onClick={() => openSaidaModal(produto)}
                                            title="Remover stock"
                                            disabled={produto.stockAtual === 0}
                                        >
                                            <span className="btn-icon">−</span> Saída
                                        </button>
                                        <button
                                            className="btn-historico"
                                            onClick={() => verHistoricoProduto(produto)}
                                            title="Ver histórico"
                                        >
                                            <Icon name="history" size={16} /> Histórico
                                        </button>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                    {renderProdutosPagination()}
                </>
            )}

            {/* ÚLTIMAS ENTRADAS - COM COLUNA ARMAZÉM */}
            {!loading && entradas.length > 0 && (
                <div className="ultimas-entradas">
                    <div className="section-header">
                        <h3><Icon name="history" size={18} /> Últimas Movimentações</h3>
                        <span className="total-registos">
                            Total: {entradas.length} registos
                        </span>
                    </div>
                    <div className="entradas-table-container">
                        <table className="entradas-table">
                            <thead>
                                <tr>
                                    <th>Data/Hora</th>
                                    <th>Produto</th>
                                    <th>Quantidade</th>
                                    <th>Preço Unit.</th>
                                    <th>Total</th>
                                    <th>Fornecedor</th>
                                    <th>Armazém</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentEntradas.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" style={{ textAlign: 'center', padding: '2rem' }}>
                                            <Icon name="inbox" size={32} color="var(--color-info-dark)" />
                                            <p style={{ marginTop: '0.5rem', color: 'var(--color-info-dark)' }}>
                                                Nenhum registo encontrado
                                            </p>
                                        </td>
                                    </tr>
                                ) : (
                                    currentEntradas.map(entrada => {
                                        const isSaida = entrada.quantidade < 0;
                                        const quantidadeAbs = Math.abs(entrada.quantidade);

                                        return (
                                            <tr key={entrada._id}>
                                                <td>{formatarDataCompleta(entrada.dataEntrada)}</td>
                                                <td>
                                                    <strong>{entrada.produtoId?.nome || 'N/A'}</strong>
                                                    <span className="produto-codigo">{entrada.produtoId?.codigo || ''}</span>
                                                </td>
                                                <td>
                                                    <span className="quantidade-badge" style={{
                                                        background: isSaida ? 'rgba(220, 38, 38, 0.12)' : 'rgba(16, 185, 129, 0.12)',
                                                        color: isSaida ? '#dc2626' : '#10b981'
                                                    }}>
                                                        {isSaida ? '-' : '+'}{quantidadeAbs}
                                                    </span>
                                                </td>
                                                <td>{formatarMoeda(entrada.precoUnitario)}</td>
                                                <td style={{ fontWeight: 700, color: isSaida ? '#dc2626' : '#4f46e5' }}>
                                                    {isSaida ? '-' : ''}{formatarMoeda(quantidadeAbs * entrada.precoUnitario)}
                                                </td>
                                                <td>{getNomeFornecedor(entrada.fornecedorId)}</td>
                                                <td>
                                                    <span className="armazem-badge">
                                                        {getNomeArmazem(entrada.armazemId)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <button
                                                        className="action-btn view"
                                                        onClick={() => verDetalhesEntrada(entrada)}
                                                        title="Ver detalhes"
                                                    >
                                                        <Icon name="visibility" size={16} />
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                        {renderPagination()}
                    </div>
                </div>
            )}
        </div>
    );
}